export type Level = 1 | 2 | 3

export type TeaserPatient = {
  id: string
  label: string
  image: string
  amh: { text: string; level: Level }
  weight: { text: string; level: Level }
}

export const teaserPatients: TeaserPatient[] = [
  {
    id: 'a',
    label: 'Patient A',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/cc574716-2a75-4a72-9c7b-e09586963c28.jpg',
    amh: { text: 'Lower', level: 1 },
    weight: { text: 'Higher', level: 3 },
  },
  {
    id: 'b',
    label: 'Patient B',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/da54934a-41fa-4330-b0a5-4fec788d8663.jpg',
    amh: { text: 'Higher', level: 3 },
    weight: { text: 'Lower', level: 1 },
  },
]

export const responseOutcomes = [
  { label: 'Too little', text: 'Potentially too few oocytes' },
  { label: 'Right response', text: 'Balance between treatment opportunity and safety', primary: true },
  { label: 'Too much', text: 'Excessive response, higher OHSS / intervention risk' },
]

export const penClipUrl = 'https://cdn.magicpatterns.com/uploads/tP2WTuENN5YnAcd49adi1U/rekovelle_magic_clip.mp4'

export const proofPoints = [
  { title: 'Comparable efficacy', placeholder: '[APPROVED EFFICACY CLAIM]' },
  { title: 'Better control of excessive response', placeholder: '[APPROVED RESPONSE / SAFETY CLAIM]' },
  { title: 'Fewer OHSS-related preventive interventions', placeholder: '[APPROVED SUPPORTING DATA]' },
]
